import React from "react";

function Hero() {
  return (
    <img
      className="object-fill w-screen"
      src="https://media.graphcms.com/t3GhtImjQv2R3wgHAfVm"
      alt=""
    ></img>
  );
}

export default Hero;
